import { SimpleMediaDeviceInfo } from '../state/media';

export interface DeviceGroup {
  selectedDevice: SimpleMediaDeviceInfo | null;
  devices: SimpleMediaDeviceInfo[];
}

export enum DeviceType {
  SPEAKER = 'Speaker',
  MICROPHONE = 'Microphone',
  CAMERA = 'Camera',
}

export enum MultimediaType {
  AUDIO = 'audio',
  CAMERA = 'camera',
}
